import { RouteConfig } from 'vue-router';

const patientExperienceRoute = [
	{
		path: '/questionnaires-experience-patient',
		name: 'patientExperienceSurvey',
		component: () => import(
			/* webpackChunkName: "patient_experience_survey" */
			'../../views/patient/PatientExperienceSurvey.vue'
		),
		meta: {
			hideHeader: true,
			disableNavigation: true,
			hideFooter: true
		}
	},
	{
		path: '/questionnaires-experience-patient/desinscription',
		name: 'patientExperienceUnsubscribe',
		component: () => import(
			/* webpackChunkName: "patient_experience_unsubscribe" */
			'../../views/patient/PatientExperienceUnsubscribe.vue'
		),
		meta: {
			hideHeader: true,
			disableNavigation: true,
			hideFooter: true
		}
	}
] as RouteConfig[];

export default patientExperienceRoute;
